import * as React from 'react';
import { IItemCardProps } from 'models/itemcard';
import * as moment from 'moment';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IShopListItem } from 'models/shop/shoplistitem';
import renderIcon from 'helpers/renderIcon';
import { manageShopLinksAdmin } from 'models/shop/manageshop';
import { Link } from 'react-router';

interface IProps extends IItemCardProps {
	item: IShopListItem;
	itemSettings?: (itemId: string) => void;
	t?: (key: string, options?: any) => string;
}

interface IState {
	isShopDropdownOpen: boolean;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdminShopItemCard extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			isShopDropdownOpen: false,
		};

		this.editItem = this.editItem.bind(this);
		this.deleteItem = this.deleteItem.bind(this);
		this.viewItem = this.viewItem.bind(this);
		this.openItemSettings = this.openItemSettings.bind(this);
	}

	public editItem() {
		if (this.props.editItem) {
			this.props.editItem(this.props.item.id);
		}
	}

	public deleteItem(e: any) {
		e.stopPropagation();
		if (this.props.deleteItem) {
			const entityIdObj: any = JSON.parse(this.props.item.entityId);
			this.props.deleteItem(entityIdObj.type, entityIdObj.id);
		}
	}

	public viewItem(e: any) {
		e.stopPropagation();
		if (this.props.viewItem) {
			this.props.viewItem(this.props.item.id);
		}
	}

	public openItemSettings(e: any) {
		e.stopPropagation();
		if (this.props.itemSettings) {
			this.props.itemSettings(this.props.item.id);
		}
	}

	public toggleShopDropdown(e: any) {
		e.stopPropagation();
		this.setState({ isShopDropdownOpen: !this.state.isShopDropdownOpen });
	}

	public render() {
		const { name, status, addedDate, picture } = this.props.item;
		const { t } = this.props;

		return (
			<div className="adminItemCard adminShopItemCard">
				<div className="innerHolder" onClick={this.viewItem}>
					<div className="image">
						{picture && <img src={picture} alt={`${name}'s picture`} />}
						{!picture && renderIcon('pfp_salon')}
					</div>

					<div className="title">{name}</div>

					<div className="viewMore">
						{renderIcon('moreHorizontal', 24, 24, 'viewMore__button', (e) => {
							this.toggleShopDropdown(e);
						})}
						<div className="viewMore__dropdown" style={{ display: this.state.isShopDropdownOpen ? 'flex' : 'none' }}>
							{manageShopLinksAdmin &&
								manageShopLinksAdmin.reduce((prev, linkItem) => {
									if ((linkItem.inHeader && !linkItem.isShopLink) || linkItem.inAdminOnly)
										prev.push(
											<Link
												to={`/shop/${this.props.item.id}/${linkItem.slug}`}
												className="settingsLink"
												key={linkItem.slug}
												onClick={(e) => {
													e.stopPropagation();
												}}
											>
												{renderIcon(linkItem.icon, undefined, undefined, 'settingsLink__icon')}
												<span>{t(linkItem.title)}</span>
											</Link>,
										);
									return prev;
								}, [])}
						</div>
					</div>

					<div className="published">
						<div className="status">{t('CodeList_ArticleStatus_' + status)}</div>
					</div>

					<div className="created-date">
						<span>{moment(addedDate).format('L')}</span>
					</div>
				</div>
			</div>
		);
	}
}

export { AdminShopItemCard };
